function pe() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function ye() {
  const t = pe();
  if (t.__xstate__)
    return t.__xstate__;
}
const ge = (t) => {
  if (typeof window > "u")
    return;
  const e = ye();
  e && e.register(t);
};
class Ot {
  constructor(e) {
    this._process = e, this._active = !1, this._current = null, this._last = null;
  }
  start() {
    this._active = !0, this.flush();
  }
  clear() {
    this._current && (this._current.next = null, this._last = this._current);
  }
  enqueue(e) {
    const s = {
      value: e,
      next: null
    };
    if (this._current) {
      this._last.next = s, this._last = s;
      return;
    }
    this._current = s, this._last = s, this._active && this.flush();
  }
  flush() {
    for (; this._current; ) {
      const e = this._current;
      this._process(e.value), this._current = e.next;
    }
    this._last = null;
  }
}
const Kt = ".", me = "", Ht = "", ve = "#", be = "*", Gt = "xstate.init", z = "xstate.stop";
function Se(t, e) {
  return {
    type: `xstate.after.${t}.${e}`
  };
}
function at(t, e) {
  return {
    type: `xstate.done.state.${t}`,
    output: e
  };
}
function _e(t, e) {
  return {
    type: `xstate.done.actor.${t}`,
    output: e,
    actorId: t
  };
}
function we(t, e) {
  return {
    type: `xstate.error.actor.${t}`,
    error: e,
    actorId: t
  };
}
function zt(t) {
  return {
    type: Gt,
    input: t
  };
}
function w(t) {
  setTimeout(() => {
    throw t;
  });
}
const Ee = typeof Symbol == "function" && Symbol.observable || "@@observable";
function Jt(t, e) {
  const s = Tt(t), n = Tt(e);
  return typeof n == "string" ? typeof s == "string" ? n === s : !1 : typeof s == "string" ? s in n : Object.keys(s).every((i) => i in n ? Jt(s[i], n[i]) : !1);
}
function yt(t) {
  if (Wt(t))
    return t;
  const e = [];
  let s = "";
  for (let n = 0; n < t.length; n++) {
    switch (t.charCodeAt(n)) {
      // \
      case 92:
        s += t[n + 1], n++;
        continue;
      // .
      case 46:
        e.push(s), s = "";
        continue;
    }
    s += t[n];
  }
  return e.push(s), e;
}
function Tt(t) {
  if (is(t))
    return t.value;
  if (typeof t != "string")
    return t;
  const e = yt(t);
  return xe(e);
}
function xe(t) {
  if (t.length === 1)
    return t[0];
  const e = {};
  let s = e;
  for (let n = 0; n < t.length - 1; n++)
    if (n === t.length - 2)
      s[t[n]] = t[n + 1];
    else {
      const i = s;
      s = {}, i[t[n]] = s;
    }
  return e;
}
function At(t, e) {
  const s = {}, n = Object.keys(t);
  for (let i = 0; i < n.length; i++) {
    const r = n[i];
    s[r] = e(t[r], r, t, i);
  }
  return s;
}
function Bt(t) {
  return Wt(t) ? t : [t];
}
function E(t) {
  return t === void 0 ? [] : Bt(t);
}
function ct(t, e, s, n) {
  return typeof t == "function" ? t({
    context: e,
    event: s,
    self: n
  }) : t;
}
function Wt(t) {
  return Array.isArray(t);
}
function Oe(t) {
  return t.type.startsWith("xstate.error.actor");
}
function C(t) {
  return Bt(t).map((e) => typeof e > "u" || typeof e == "string" ? {
    target: e
  } : e);
}
function Xt(t) {
  if (!(t === void 0 || t === me))
    return E(t);
}
function ut(t, e, s) {
  const n = typeof t == "object", i = n ? t : void 0;
  return {
    next: (n ? t.next : t)?.bind(i),
    error: (n ? t.error : e)?.bind(i),
    complete: (n ? t.complete : s)?.bind(i)
  };
}
function It(t, e) {
  return `${e}.${t}`;
}
function gt(t, e) {
  const s = e.match(/^xstate\.invoke\.(\d+)\.(.*)/);
  if (!s)
    return t.implementations.actors[e];
  const [, n, i] = s, o = t.getStateNodeById(i).config.invoke;
  return (Array.isArray(o) ? o[n] : o).src;
}
function kt(t, e) {
  return `${t.sessionId}.${e}`;
}
let Te = 0;
function Ae(t, e) {
  const s = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new Set(), o = {}, {
    clock: a,
    logger: c
  } = e, f = {
    schedule: (h, d, l, y, g = Math.random().toString(36).slice(2)) => {
      const m = {
        source: h,
        target: d,
        event: l,
        delay: y,
        id: g,
        startedAt: Date.now()
      }, b = kt(h, g);
      u._snapshot._scheduledEvents[b] = m;
      const O = a.setTimeout(() => {
        delete o[b], delete u._snapshot._scheduledEvents[b], u._relay(h, d, l);
      }, y);
      o[b] = O;
    },
    cancel: (h, d) => {
      const l = kt(h, d), y = o[l];
      delete o[l], delete u._snapshot._scheduledEvents[l], y !== void 0 && a.clearTimeout(y);
    },
    cancelAll: (h) => {
      for (const d in u._snapshot._scheduledEvents) {
        const l = u._snapshot._scheduledEvents[d];
        l.source === h && f.cancel(h, l.id);
      }
    }
  }, p = (h) => {
    if (!r.size)
      return;
    const d = {
      ...h,
      rootId: t.sessionId
    };
    r.forEach((l) => l.next?.(d));
  }, u = {
    _snapshot: {
      _scheduledEvents: (e?.snapshot && e.snapshot.scheduler) ?? {}
    },
    _bookId: () => `x:${Te++}`,
    _register: (h, d) => (s.set(h, d), h),
    _unregister: (h) => {
      s.delete(h.sessionId);
      const d = i.get(h);
      d !== void 0 && (n.delete(d), i.delete(h));
    },
    get: (h) => n.get(h),
    _set: (h, d) => {
      const l = n.get(h);
      if (l && l !== d)
        throw new Error(`Actor with system ID '${h}' already exists.`);
      n.set(h, d), i.set(d, h);
    },
    inspect: (h) => {
      const d = ut(h);
      return r.add(d), {
        unsubscribe() {
          r.delete(d);
        }
      };
    },
    _sendInspectionEvent: p,
    _relay: (h, d, l) => {
      u._sendInspectionEvent({
        type: "@xstate.event",
        sourceRef: h,
        actorRef: d,
        event: l
      }), d._send(l);
    },
    scheduler: f,
    getSnapshot: () => ({
      _scheduledEvents: {
        ...u._snapshot._scheduledEvents
      }
    }),
    start: () => {
      const h = u._snapshot._scheduledEvents;
      u._snapshot._scheduledEvents = {};
      for (const d in h) {
        const {
          source: l,
          target: y,
          event: g,
          delay: m,
          id: b
        } = h[d];
        f.schedule(l, y, g, m, b);
      }
    },
    _clock: a,
    _logger: c
  };
  return u;
}
let st = !1;
const mt = 1;
let S = /* @__PURE__ */ function(t) {
  return t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped", t;
}({});
const Ie = {
  clock: {
    setTimeout: (t, e) => setTimeout(t, e),
    clearTimeout: (t) => clearTimeout(t)
  },
  logger: console.log.bind(console),
  devTools: !1
};
class ke {
  /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */
  constructor(e, s) {
    this.logic = e, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new Ot(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = S.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this._systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
    const n = {
      ...Ie,
      ...s
    }, {
      clock: i,
      logger: r,
      parent: o,
      syncSnapshot: a,
      id: c,
      systemId: f,
      inspect: p
    } = n;
    this.system = o ? o.system : Ae(this, {
      clock: i,
      logger: r
    }), p && !o && this.system.inspect(ut(p)), this.sessionId = this.system._bookId(), this.id = c ?? this.sessionId, this.logger = s?.logger ?? this.system._logger, this.clock = s?.clock ?? this.system._clock, this._parent = o, this._syncSnapshot = a, this.options = n, this.src = n.src ?? e, this.ref = this, this._actorScope = {
      self: this,
      id: this.id,
      sessionId: this.sessionId,
      logger: this.logger,
      defer: (u) => {
        this._deferred.push(u);
      },
      system: this.system,
      stopChild: (u) => {
        if (u._parent !== this)
          throw new Error(`Cannot stop child actor ${u.id} of ${this.id} because it is not a child`);
        u._stop();
      },
      emit: (u) => {
        const h = this.eventListeners.get(u.type), d = this.eventListeners.get("*");
        if (!h && !d)
          return;
        const l = [...h ? h.values() : [], ...d ? d.values() : []];
        for (const y of l)
          y(u);
      },
      actionExecutor: (u) => {
        const h = () => {
          if (this._actorScope.system._sendInspectionEvent({
            type: "@xstate.action",
            actorRef: this,
            action: {
              type: u.type,
              params: u.params
            }
          }), !u.exec)
            return;
          const d = st;
          try {
            st = !0, u.exec(u.info, u.params);
          } finally {
            st = d;
          }
        };
        this._processingStatus === S.Running ? h() : this._deferred.push(h);
      }
    }, this.send = this.send.bind(this), this.system._sendInspectionEvent({
      type: "@xstate.actor",
      actorRef: this
    }), f && (this._systemId = f, this.system._set(f, this)), this._initState(s?.snapshot ?? s?.state), f && this._snapshot.status !== "active" && this.system._unregister(this);
  }
  _initState(e) {
    try {
      this._snapshot = e ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(e, this._actorScope) : e : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
    } catch (s) {
      this._snapshot = {
        status: "error",
        output: void 0,
        error: s
      };
    }
  }
  update(e, s) {
    this._snapshot = e;
    let n;
    for (; n = this._deferred.shift(); )
      try {
        n();
      } catch (i) {
        this._deferred.length = 0, this._snapshot = {
          ...e,
          status: "error",
          error: i
        };
      }
    switch (this._snapshot.status) {
      case "active":
        for (const i of this.observers)
          try {
            i.next?.(e);
          } catch (r) {
            w(r);
          }
        break;
      case "done":
        for (const i of this.observers)
          try {
            i.next?.(e);
          } catch (r) {
            w(r);
          }
        this._stopProcedure(), this._complete(), this._doneEvent = _e(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
        break;
      case "error":
        this._error(this._snapshot.error);
        break;
    }
    this.system._sendInspectionEvent({
      type: "@xstate.snapshot",
      actorRef: this,
      event: s,
      snapshot: e
    });
  }
  /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */
  subscribe(e, s, n) {
    const i = ut(e, s, n);
    if (this._processingStatus !== S.Stopped)
      this.observers.add(i);
    else
      switch (this._snapshot.status) {
        case "done":
          try {
            i.complete?.();
          } catch (r) {
            w(r);
          }
          break;
        case "error": {
          const r = this._snapshot.error;
          if (!i.error)
            w(r);
          else
            try {
              i.error(r);
            } catch (o) {
              w(o);
            }
          break;
        }
      }
    return {
      unsubscribe: () => {
        this.observers.delete(i);
      }
    };
  }
  on(e, s) {
    let n = this.eventListeners.get(e);
    n || (n = /* @__PURE__ */ new Set(), this.eventListeners.set(e, n));
    const i = s.bind(void 0);
    return n.add(i), {
      unsubscribe: () => {
        n.delete(i);
      }
    };
  }
  /** Starts the Actor from the initial state */
  start() {
    if (this._processingStatus === S.Running)
      return this;
    this._syncSnapshot && this.subscribe({
      next: (n) => {
        n.status === "active" && this.system._relay(this, this._parent, {
          type: `xstate.snapshot.${this.id}`,
          snapshot: n
        });
      },
      error: () => {
      }
    }), this.system._register(this.sessionId, this), this._systemId && this.system._set(this._systemId, this), this._processingStatus = S.Running;
    const e = zt(this.options.input);
    switch (this.system._sendInspectionEvent({
      type: "@xstate.event",
      sourceRef: this._parent,
      actorRef: this,
      event: e
    }), this._snapshot.status) {
      case "done":
        return this.update(this._snapshot, e), this;
      case "error":
        return this._error(this._snapshot.error), this;
    }
    if (this._parent || this.system.start(), this.logic.start)
      try {
        this.logic.start(this._snapshot, this._actorScope);
      } catch (n) {
        return this._snapshot = {
          ...this._snapshot,
          status: "error",
          error: n
        }, this._error(n), this;
      }
    return this.update(this._snapshot, e), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
  }
  _process(e) {
    let s, n;
    try {
      s = this.logic.transition(this._snapshot, e, this._actorScope);
    } catch (i) {
      n = {
        err: i
      };
    }
    if (n) {
      const {
        err: i
      } = n;
      this._snapshot = {
        ...this._snapshot,
        status: "error",
        error: i
      }, this._error(i);
      return;
    }
    this.update(s, e), e.type === z && (this._stopProcedure(), this._complete());
  }
  _stop() {
    return this._processingStatus === S.Stopped ? this : (this.mailbox.clear(), this._processingStatus === S.NotStarted ? (this._processingStatus = S.Stopped, this) : (this.mailbox.enqueue({
      type: z
    }), this));
  }
  /** Stops the Actor and unsubscribe all listeners. */
  stop() {
    if (this._parent)
      throw new Error("A non-root actor cannot be stopped directly.");
    return this._stop();
  }
  _complete() {
    for (const e of this.observers)
      try {
        e.complete?.();
      } catch (s) {
        w(s);
      }
    this.observers.clear();
  }
  _reportError(e) {
    if (!this.observers.size) {
      this._parent || w(e);
      return;
    }
    let s = !1;
    for (const n of this.observers) {
      const i = n.error;
      s ||= !i;
      try {
        i?.(e);
      } catch (r) {
        w(r);
      }
    }
    this.observers.clear(), s && w(e);
  }
  _error(e) {
    this._stopProcedure(), this._reportError(e), this._parent && this.system._relay(this, this._parent, we(this.id, e));
  }
  // TODO: atm children don't belong entirely to the actor so
  // in a way - it's not even super aware of them
  // so we can't stop them from here but we really should!
  // right now, they are being stopped within the machine's transition
  // but that could throw and leave us with "orphaned" active actors
  _stopProcedure() {
    return this._processingStatus !== S.Running ? this : (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new Ot(this._process.bind(this)), this._processingStatus = S.Stopped, this.system._unregister(this), this);
  }
  /** @internal */
  _send(e) {
    this._processingStatus !== S.Stopped && this.mailbox.enqueue(e);
  }
  /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */
  send(e) {
    this.system._relay(void 0, this, e);
  }
  attachDevTools() {
    const {
      devTools: e
    } = this.options;
    e && (typeof e == "function" ? e : ge)(this);
  }
  toJSON() {
    return {
      xstate$$type: mt,
      id: this.id
    };
  }
  /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */
  getPersistedSnapshot(e) {
    return this.logic.getPersistedSnapshot(this._snapshot, e);
  }
  [Ee]() {
    return this;
  }
  /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */
  getSnapshot() {
    return this._snapshot;
  }
}
function J(t, ...[e]) {
  return new ke(t, e);
}
function Me(t, e, s, n, {
  sendId: i
}) {
  const r = typeof i == "function" ? i(s, n) : i;
  return [e, {
    sendId: r
  }, void 0];
}
function Ce(t, e) {
  t.defer(() => {
    t.system.scheduler.cancel(t.self, e.sendId);
  });
}
function Pe(t) {
  function e(s, n) {
  }
  return e.type = "xstate.cancel", e.sendId = t, e.resolve = Me, e.execute = Ce, e;
}
function Fe(t, e, s, n, {
  id: i,
  systemId: r,
  src: o,
  input: a,
  syncSnapshot: c
}) {
  const f = typeof o == "string" ? gt(e.machine, o) : o, p = typeof i == "function" ? i(s) : i;
  let u, h;
  return f && (h = typeof a == "function" ? a({
    context: e.context,
    event: s.event,
    self: t.self
  }) : a, u = J(f, {
    id: p,
    src: o,
    parent: t.self,
    syncSnapshot: c,
    systemId: r,
    input: h
  })), [I(e, {
    children: {
      ...e.children,
      [p]: u
    }
  }), {
    id: i,
    systemId: r,
    actorRef: u,
    src: o,
    input: h
  }, void 0];
}
function De(t, {
  actorRef: e
}) {
  e && t.defer(() => {
    e._processingStatus !== S.Stopped && e.start();
  });
}
function Re(...[t, {
  id: e,
  systemId: s,
  input: n,
  syncSnapshot: i = !1
} = {}]) {
  function r(o, a) {
  }
  return r.type = "xstate.spawnChild", r.id = e, r.systemId = s, r.src = t, r.input = n, r.syncSnapshot = i, r.resolve = Fe, r.execute = De, r;
}
function $e(t, e, s, n, {
  actorRef: i
}) {
  const r = typeof i == "function" ? i(s, n) : i, o = typeof r == "string" ? e.children[r] : r;
  let a = e.children;
  return o && (a = {
    ...a
  }, delete a[o.id]), [I(e, {
    children: a
  }), o, void 0];
}
function je(t, e) {
  if (e) {
    if (t.system._unregister(e), e._processingStatus !== S.Running) {
      t.stopChild(e);
      return;
    }
    t.defer(() => {
      t.stopChild(e);
    });
  }
}
function Yt(t) {
  function e(s, n) {
  }
  return e.type = "xstate.stopChild", e.actorRef = t, e.resolve = $e, e.execute = je, e;
}
function qe(t, {
  context: e,
  event: s
}, {
  guards: n
}) {
  return n.every((i) => N(i, e, s, t));
}
function Bs(t) {
  function e(s, n) {
    return !1;
  }
  return e.check = qe, e.guards = t, e;
}
function N(t, e, s, n) {
  const {
    machine: i
  } = n, r = typeof t == "function", o = r ? t : i.implementations.guards[typeof t == "string" ? t : t.type];
  if (!r && !o)
    throw new Error(`Guard '${typeof t == "string" ? t : t.type}' is not implemented.'.`);
  if (typeof o != "function")
    return N(o, e, s, n);
  const a = {
    context: e,
    event: s
  }, c = r || typeof t == "string" ? void 0 : "params" in t ? typeof t.params == "function" ? t.params({
    context: e,
    event: s
  }) : t.params : void 0;
  return "check" in o ? o.check(
    n,
    a,
    o
    // this holds all params
  ) : o(a, c);
}
const vt = (t) => t.type === "atomic" || t.type === "final";
function F(t) {
  return Object.values(t.states).filter((e) => e.type !== "history");
}
function q(t, e) {
  const s = [];
  if (e === t)
    return s;
  let n = t.parent;
  for (; n && n !== e; )
    s.push(n), n = n.parent;
  return s;
}
function B(t) {
  const e = new Set(t), s = Zt(e);
  for (const n of e)
    if (n.type === "compound" && (!s.get(n) || !s.get(n).length))
      Mt(n).forEach((i) => e.add(i));
    else if (n.type === "parallel") {
      for (const i of F(n))
        if (i.type !== "history" && !e.has(i)) {
          const r = Mt(i);
          for (const o of r)
            e.add(o);
        }
    }
  for (const n of e) {
    let i = n.parent;
    for (; i; )
      e.add(i), i = i.parent;
  }
  return e;
}
function Vt(t, e) {
  const s = e.get(t);
  if (!s)
    return {};
  if (t.type === "compound") {
    const i = s[0];
    if (i) {
      if (vt(i))
        return i.key;
    } else
      return {};
  }
  const n = {};
  for (const i of s)
    n[i.key] = Vt(i, e);
  return n;
}
function Zt(t) {
  const e = /* @__PURE__ */ new Map();
  for (const s of t)
    e.has(s) || e.set(s, []), s.parent && (e.has(s.parent) || e.set(s.parent, []), e.get(s.parent).push(s));
  return e;
}
function Nt(t, e) {
  const s = B(e);
  return Vt(t, Zt(s));
}
function bt(t, e) {
  return e.type === "compound" ? F(e).some((s) => s.type === "final" && t.has(s)) : e.type === "parallel" ? F(e).every((s) => bt(t, s)) : e.type === "final";
}
const tt = (t) => t[0] === ve;
function Qe(t, e) {
  return t.transitions.get(e) || [...t.transitions.keys()].filter((n) => {
    if (n === be)
      return !0;
    if (!n.endsWith(".*"))
      return !1;
    const i = n.split("."), r = e.split(".");
    for (let o = 0; o < i.length; o++) {
      const a = i[o], c = r[o];
      if (a === "*")
        return o === i.length - 1;
      if (a !== c)
        return !1;
    }
    return !0;
  }).sort((n, i) => i.length - n.length).flatMap((n) => t.transitions.get(n));
}
function Le(t) {
  const e = t.config.after;
  if (!e)
    return [];
  const s = (i) => {
    const r = Se(i, t.id), o = r.type;
    return t.entry.push(ps(r, {
      id: o,
      delay: i
    })), t.exit.push(Pe(o)), o;
  };
  return Object.keys(e).flatMap((i) => {
    const r = e[i], o = typeof r == "string" ? {
      target: r
    } : r, a = Number.isNaN(+i) ? i : +i, c = s(a);
    return E(o).map((f) => ({
      ...f,
      event: c,
      delay: a
    }));
  }).map((i) => {
    const {
      delay: r
    } = i;
    return {
      ...T(t, i.event, i),
      delay: r
    };
  });
}
function T(t, e, s) {
  const n = Xt(s.target), i = s.reenter ?? !1, r = He(t, n), o = {
    ...s,
    actions: E(s.actions),
    guard: s.guard,
    target: r,
    source: t,
    reenter: i,
    eventType: e,
    toJSON: () => ({
      ...o,
      source: `#${t.id}`,
      target: r ? r.map((a) => `#${a.id}`) : void 0
    })
  };
  return o;
}
function Ue(t) {
  const e = /* @__PURE__ */ new Map();
  if (t.config.on)
    for (const s of Object.keys(t.config.on)) {
      if (s === Ht)
        throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
      const n = t.config.on[s];
      e.set(s, C(n).map((i) => T(t, s, i)));
    }
  if (t.config.onDone) {
    const s = `xstate.done.state.${t.id}`;
    e.set(s, C(t.config.onDone).map((n) => T(t, s, n)));
  }
  for (const s of t.invoke) {
    if (s.onDone) {
      const n = `xstate.done.actor.${s.id}`;
      e.set(n, C(s.onDone).map((i) => T(t, n, i)));
    }
    if (s.onError) {
      const n = `xstate.error.actor.${s.id}`;
      e.set(n, C(s.onError).map((i) => T(t, n, i)));
    }
    if (s.onSnapshot) {
      const n = `xstate.snapshot.${s.id}`;
      e.set(n, C(s.onSnapshot).map((i) => T(t, n, i)));
    }
  }
  for (const s of t.after) {
    let n = e.get(s.eventType);
    n || (n = [], e.set(s.eventType, n)), n.push(s);
  }
  return e;
}
function Ke(t, e) {
  const s = typeof e == "string" ? t.states[e] : e ? t.states[e.target] : void 0;
  if (!s && e)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-base-to-string
      `Initial state node "${e}" not found on parent state node #${t.id}`
    );
  const n = {
    source: t,
    actions: !e || typeof e == "string" ? [] : E(e.actions),
    eventType: null,
    reenter: !1,
    target: s ? [s] : [],
    toJSON: () => ({
      ...n,
      source: `#${t.id}`,
      target: s ? [`#${s.id}`] : []
    })
  };
  return n;
}
function He(t, e) {
  if (e !== void 0)
    return e.map((s) => {
      if (typeof s != "string")
        return s;
      if (tt(s))
        return t.machine.getStateNodeById(s);
      const n = s[0] === Kt;
      if (n && !t.parent)
        return W(t, s.slice(1));
      const i = n ? t.key + s : s;
      if (t.parent)
        try {
          return W(t.parent, i);
        } catch (r) {
          throw new Error(`Invalid transition definition for state node '${t.id}':
${r.message}`);
        }
      else
        throw new Error(`Invalid target: "${s}" is not a valid target from the root node. Did you mean ".${s}"?`);
    });
}
function te(t) {
  const e = Xt(t.config.target);
  return e ? {
    target: e.map((s) => typeof s == "string" ? W(t.parent, s) : s)
  } : t.parent.initial;
}
function A(t) {
  return t.type === "history";
}
function Mt(t) {
  const e = ee(t);
  for (const s of e)
    for (const n of q(s, t))
      e.add(n);
  return e;
}
function ee(t) {
  const e = /* @__PURE__ */ new Set();
  function s(n) {
    if (!e.has(n)) {
      if (e.add(n), n.type === "compound")
        s(n.initial.target[0]);
      else if (n.type === "parallel")
        for (const i of F(n))
          s(i);
    }
  }
  return s(t), e;
}
function D(t, e) {
  if (tt(e))
    return t.machine.getStateNodeById(e);
  if (!t.states)
    throw new Error(`Unable to retrieve child state '${e}' from '${t.id}'; no child states exist.`);
  const s = t.states[e];
  if (!s)
    throw new Error(`Child state '${e}' does not exist on '${t.id}'`);
  return s;
}
function W(t, e) {
  if (typeof e == "string" && tt(e))
    try {
      return t.machine.getStateNodeById(e);
    } catch {
    }
  const s = yt(e).slice();
  let n = t;
  for (; s.length; ) {
    const i = s.shift();
    if (!i.length)
      break;
    n = D(n, i);
  }
  return n;
}
function X(t, e) {
  if (typeof e == "string") {
    const i = t.states[e];
    if (!i)
      throw new Error(`State '${e}' does not exist on '${t.id}'`);
    return [t, i];
  }
  const s = Object.keys(e), n = s.map((i) => D(t, i)).filter(Boolean);
  return [t.machine.root, t].concat(n, s.reduce((i, r) => {
    const o = D(t, r);
    if (!o)
      return i;
    const a = X(o, e[r]);
    return i.concat(a);
  }, []));
}
function Ge(t, e, s, n) {
  const r = D(t, e).next(s, n);
  return !r || !r.length ? t.next(s, n) : r;
}
function ze(t, e, s, n) {
  const i = Object.keys(e), r = D(t, i[0]), o = St(r, e[i[0]], s, n);
  return !o || !o.length ? t.next(s, n) : o;
}
function Je(t, e, s, n) {
  const i = [];
  for (const r of Object.keys(e)) {
    const o = e[r];
    if (!o)
      continue;
    const a = D(t, r), c = St(a, o, s, n);
    c && i.push(...c);
  }
  return i.length ? i : t.next(s, n);
}
function St(t, e, s, n) {
  return typeof e == "string" ? Ge(t, e, s, n) : Object.keys(e).length === 1 ? ze(t, e, s, n) : Je(t, e, s, n);
}
function Be(t) {
  return Object.keys(t.states).map((e) => t.states[e]).filter((e) => e.type === "history");
}
function x(t, e) {
  let s = t;
  for (; s.parent && s.parent !== e; )
    s = s.parent;
  return s.parent === e;
}
function We(t, e) {
  const s = new Set(t), n = new Set(e);
  for (const i of s)
    if (n.has(i))
      return !0;
  for (const i of n)
    if (s.has(i))
      return !0;
  return !1;
}
function se(t, e, s) {
  const n = /* @__PURE__ */ new Set();
  for (const i of t) {
    let r = !1;
    const o = /* @__PURE__ */ new Set();
    for (const a of n)
      if (We(ht([i], e, s), ht([a], e, s)))
        if (x(i.source, a.source))
          o.add(a);
        else {
          r = !0;
          break;
        }
    if (!r) {
      for (const a of o)
        n.delete(a);
      n.add(i);
    }
  }
  return Array.from(n);
}
function Xe(t) {
  const [e, ...s] = t;
  for (const n of q(e, void 0))
    if (s.every((i) => x(i, n)))
      return n;
}
function _t(t, e) {
  if (!t.target)
    return [];
  const s = /* @__PURE__ */ new Set();
  for (const n of t.target)
    if (A(n))
      if (e[n.id])
        for (const i of e[n.id])
          s.add(i);
      else
        for (const i of _t(te(n), e))
          s.add(i);
    else
      s.add(n);
  return [...s];
}
function ne(t, e) {
  const s = _t(t, e);
  if (!s)
    return;
  if (!t.reenter && s.every((i) => i === t.source || x(i, t.source)))
    return t.source;
  const n = Xe(s.concat(t.source));
  if (n)
    return n;
  if (!t.reenter)
    return t.source.machine.root;
}
function ht(t, e, s) {
  const n = /* @__PURE__ */ new Set();
  for (const i of t)
    if (i.target?.length) {
      const r = ne(i, s);
      i.reenter && i.source === r && n.add(r);
      for (const o of e)
        x(o, r) && n.add(o);
    }
  return [...n];
}
function Ye(t, e) {
  if (t.length !== e.size)
    return !1;
  for (const s of t)
    if (!e.has(s))
      return !1;
  return !0;
}
function ft(t, e, s, n, i, r) {
  if (!t.length)
    return e;
  const o = new Set(e._nodes);
  let a = e.historyValue;
  const c = se(t, o, a);
  let f = e;
  i || ([f, a] = ts(f, n, s, c, o, a, r, s.actionExecutor)), f = R(f, n, s, c.flatMap((u) => u.actions), r, void 0), f = Ze(f, n, s, c, o, r, a, i);
  const p = [...o];
  f.status === "done" && (f = R(f, n, s, p.sort((u, h) => h.order - u.order).flatMap((u) => u.exit), r, void 0));
  try {
    return a === e.historyValue && Ye(e._nodes, o) ? f : I(f, {
      _nodes: p,
      historyValue: a
    });
  } catch (u) {
    throw u;
  }
}
function Ve(t, e, s, n, i) {
  if (n.output === void 0)
    return;
  const r = at(i.id, i.output !== void 0 && i.parent ? ct(i.output, t.context, e, s.self) : void 0);
  return ct(n.output, t.context, r, s.self);
}
function Ze(t, e, s, n, i, r, o, a) {
  let c = t;
  const f = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new Set();
  Ne(n, o, p, f), a && p.add(t.machine.root);
  const u = /* @__PURE__ */ new Set();
  for (const h of [...f].sort((d, l) => d.order - l.order)) {
    i.add(h);
    const d = [];
    d.push(...h.entry);
    for (const l of h.invoke)
      d.push(Re(l.src, {
        ...l,
        syncSnapshot: !!l.onSnapshot
      }));
    if (p.has(h)) {
      const l = h.initial.actions;
      d.push(...l);
    }
    if (c = R(c, e, s, d, r, h.invoke.map((l) => l.id)), h.type === "final") {
      const l = h.parent;
      let y = l?.type === "parallel" ? l : l?.parent, g = y || h;
      for (l?.type === "compound" && r.push(at(l.id, h.output !== void 0 ? ct(h.output, c.context, e, s.self) : void 0)); y?.type === "parallel" && !u.has(y) && bt(i, y); )
        u.add(y), r.push(at(y.id)), g = y, y = y.parent;
      if (y)
        continue;
      c = I(c, {
        status: "done",
        output: Ve(c, e, s, c.machine.root, g)
      });
    }
  }
  return c;
}
function Ne(t, e, s, n) {
  for (const i of t) {
    const r = ne(i, e);
    for (const a of i.target || [])
      !A(a) && // if the target is different than the source then it will *definitely* be entered
      (i.source !== a || // we know that the domain can't lie within the source
      // if it's different than the source then it's outside of it and it means that the target has to be entered as well
      i.source !== r || // reentering transitions always enter the target, even if it's the source itself
      i.reenter) && (n.add(a), s.add(a)), P(a, e, s, n);
    const o = _t(i, e);
    for (const a of o) {
      const c = q(a, r);
      r?.type === "parallel" && c.push(r), ie(n, e, s, c, !i.source.parent && i.reenter ? void 0 : r);
    }
  }
}
function P(t, e, s, n) {
  if (A(t))
    if (e[t.id]) {
      const i = e[t.id];
      for (const r of i)
        n.add(r), P(r, e, s, n);
      for (const r of i)
        nt(r, t.parent, n, e, s);
    } else {
      const i = te(t);
      for (const r of i.target)
        n.add(r), i === t.parent?.initial && s.add(t.parent), P(r, e, s, n);
      for (const r of i.target)
        nt(r, t.parent, n, e, s);
    }
  else if (t.type === "compound") {
    const [i] = t.initial.target;
    A(i) || (n.add(i), s.add(i)), P(i, e, s, n), nt(i, t, n, e, s);
  } else if (t.type === "parallel")
    for (const i of F(t).filter((r) => !A(r)))
      [...n].some((r) => x(r, i)) || (A(i) || (n.add(i), s.add(i)), P(i, e, s, n));
}
function ie(t, e, s, n, i) {
  for (const r of n)
    if ((!i || x(r, i)) && t.add(r), r.type === "parallel")
      for (const o of F(r).filter((a) => !A(a)))
        [...t].some((a) => x(a, o)) || (t.add(o), P(o, e, s, t));
}
function nt(t, e, s, n, i) {
  ie(s, n, i, q(t, e));
}
function ts(t, e, s, n, i, r, o, a) {
  let c = t;
  const f = ht(n, i, r);
  f.sort((u, h) => h.order - u.order);
  let p;
  for (const u of f)
    for (const h of Be(u)) {
      let d;
      h.history === "deep" ? d = (l) => vt(l) && x(l, u) : d = (l) => l.parent === u, p ??= {
        ...r
      }, p[h.id] = Array.from(i).filter(d);
    }
  for (const u of f)
    c = R(c, e, s, [...u.exit, ...u.invoke.map((h) => Yt(h.id))], o, void 0), i.delete(u);
  return [c, p || r];
}
function es(t, e) {
  return t.implementations.actions[e];
}
function re(t, e, s, n, i, r) {
  const {
    machine: o
  } = t;
  let a = t;
  for (const c of n) {
    const f = typeof c == "function", p = f ? c : (
      // the existing type of `.actions` assumes non-nullable `TExpressionAction`
      // it's fine to cast this here to get a common type and lack of errors in the rest of the code
      // our logic below makes sure that we call those 2 "variants" correctly
      es(o, typeof c == "string" ? c : c.type)
    ), u = {
      context: a.context,
      event: e,
      self: s.self,
      system: s.system
    }, h = f || typeof c == "string" ? void 0 : "params" in c ? typeof c.params == "function" ? c.params({
      context: a.context,
      event: e
    }) : c.params : void 0;
    if (!p || !("resolve" in p)) {
      s.actionExecutor({
        type: typeof c == "string" ? c : typeof c == "object" ? c.type : c.name || "(anonymous)",
        info: u,
        params: h,
        exec: p
      });
      continue;
    }
    const d = p, [l, y, g] = d.resolve(
      s,
      a,
      u,
      h,
      p,
      // this holds all params
      i
    );
    a = l, "retryResolve" in d && r?.push([d, y]), "execute" in d && s.actionExecutor({
      type: d.type,
      info: u,
      params: y,
      exec: d.execute.bind(null, s, y)
    }), g && (a = re(a, e, s, g, i, r));
  }
  return a;
}
function R(t, e, s, n, i, r) {
  const o = r ? [] : void 0, a = re(t, e, s, n, {
    internalQueue: i,
    deferredActorIds: r
  }, o);
  return o?.forEach(([c, f]) => {
    c.retryResolve(s, a, f);
  }), a;
}
function it(t, e, s, n) {
  let i = t;
  const r = [];
  function o(f, p, u) {
    s.system._sendInspectionEvent({
      type: "@xstate.microstep",
      actorRef: s.self,
      event: p,
      snapshot: f,
      _transitions: u
    }), r.push(f);
  }
  if (e.type === z)
    return i = I(Ct(i, e, s), {
      status: "stopped"
    }), o(i, e, []), {
      snapshot: i,
      microstates: r
    };
  let a = e;
  if (a.type !== Gt) {
    const f = a, p = Oe(f), u = Pt(f, i);
    if (p && !u.length)
      return i = I(t, {
        status: "error",
        error: f.error
      }), o(i, f, []), {
        snapshot: i,
        microstates: r
      };
    i = ft(
      u,
      t,
      s,
      a,
      !1,
      // isInitial
      n
    ), o(i, f, u);
  }
  let c = !0;
  for (; i.status === "active"; ) {
    let f = c ? ss(i, a) : [];
    const p = f.length ? i : void 0;
    if (!f.length) {
      if (!n.length)
        break;
      a = n.shift(), f = Pt(a, i);
    }
    i = ft(f, i, s, a, !1, n), c = i !== p, o(i, a, f);
  }
  return i.status !== "active" && Ct(i, a, s), {
    snapshot: i,
    microstates: r
  };
}
function Ct(t, e, s) {
  return R(t, e, s, Object.values(t.children).map((n) => Yt(n)), [], void 0);
}
function Pt(t, e) {
  return e.machine.getTransitionData(e, t);
}
function ss(t, e) {
  const s = /* @__PURE__ */ new Set(), n = t._nodes.filter(vt);
  for (const i of n)
    t: for (const r of [i].concat(q(i, void 0)))
      if (r.always) {
        for (const o of r.always)
          if (o.guard === void 0 || N(o.guard, t.context, e, t)) {
            s.add(o);
            break t;
          }
      }
  return se(Array.from(s), new Set(t._nodes), t.historyValue);
}
function ns(t, e) {
  const s = B(X(t, e));
  return Nt(t, [...s]);
}
function is(t) {
  return !!t && typeof t == "object" && "machine" in t && "value" in t;
}
const rs = function(e) {
  return Jt(e, this.value);
}, os = function(e) {
  return this.tags.has(e);
}, as = function(e) {
  const s = this.machine.getTransitionData(this, e);
  return !!s?.length && // Check that at least one transition is not forbidden
  s.some((n) => n.target !== void 0 || n.actions.length);
}, cs = function() {
  const {
    _nodes: e,
    tags: s,
    machine: n,
    getMeta: i,
    toJSON: r,
    can: o,
    hasTag: a,
    matches: c,
    ...f
  } = this;
  return {
    ...f,
    tags: Array.from(s)
  };
}, us = function() {
  return this._nodes.reduce((e, s) => (s.meta !== void 0 && (e[s.id] = s.meta), e), {});
};
function G(t, e) {
  return {
    status: t.status,
    output: t.output,
    error: t.error,
    machine: e,
    context: t.context,
    _nodes: t._nodes,
    value: Nt(e.root, t._nodes),
    tags: new Set(t._nodes.flatMap((s) => s.tags)),
    children: t.children,
    historyValue: t.historyValue || {},
    matches: rs,
    hasTag: os,
    can: as,
    getMeta: us,
    toJSON: cs
  };
}
function I(t, e = {}) {
  return G({
    ...t,
    ...e
  }, t.machine);
}
function hs(t) {
  if (typeof t != "object" || t === null)
    return {};
  const e = {};
  for (const s in t) {
    const n = t[s];
    Array.isArray(n) && (e[s] = n.map((i) => ({
      id: i.id
    })));
  }
  return e;
}
function fs(t, e) {
  const {
    _nodes: s,
    tags: n,
    machine: i,
    children: r,
    context: o,
    can: a,
    hasTag: c,
    matches: f,
    getMeta: p,
    toJSON: u,
    ...h
  } = t, d = {};
  for (const y in r) {
    const g = r[y];
    d[y] = {
      snapshot: g.getPersistedSnapshot(e),
      src: g.src,
      systemId: g._systemId,
      syncSnapshot: g._syncSnapshot
    };
  }
  return {
    ...h,
    context: oe(o),
    children: d,
    historyValue: hs(h.historyValue)
  };
}
function oe(t) {
  let e;
  for (const s in t) {
    const n = t[s];
    if (n && typeof n == "object")
      if ("sessionId" in n && "send" in n && "ref" in n)
        e ??= Array.isArray(t) ? t.slice() : {
          ...t
        }, e[s] = {
          xstate$$type: mt,
          id: n.id
        };
      else {
        const i = oe(n);
        i !== n && (e ??= Array.isArray(t) ? t.slice() : {
          ...t
        }, e[s] = i);
      }
  }
  return e ?? t;
}
function ls(t, e, s, n, {
  event: i,
  id: r,
  delay: o
}, {
  internalQueue: a
}) {
  const c = e.machine.implementations.delays;
  if (typeof i == "string")
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `Only event objects may be used with raise; use raise({ type: "${i}" }) instead`
    );
  const f = typeof i == "function" ? i(s, n) : i;
  let p;
  if (typeof o == "string") {
    const u = c && c[o];
    p = typeof u == "function" ? u(s, n) : u;
  } else
    p = typeof o == "function" ? o(s, n) : o;
  return typeof p != "number" && a.push(f), [e, {
    event: f,
    id: r,
    delay: p
  }, void 0];
}
function ds(t, e) {
  const {
    event: s,
    delay: n,
    id: i
  } = e;
  if (typeof n == "number") {
    t.defer(() => {
      const r = t.self;
      t.system.scheduler.schedule(r, r, s, n, i);
    });
    return;
  }
}
function ps(t, e) {
  function s(n, i) {
  }
  return s.type = "xstate.raise", s.event = t, s.id = e?.id, s.delay = e?.delay, s.resolve = ls, s.execute = ds, s;
}
const Ft = "xstate.promise.resolve", Dt = "xstate.promise.reject", K = /* @__PURE__ */ new WeakMap();
function Ws(t) {
  return {
    config: t,
    transition: (s, n, i) => {
      if (s.status !== "active")
        return s;
      switch (n.type) {
        case Ft: {
          const r = n.data;
          return {
            ...s,
            status: "done",
            output: r,
            input: void 0
          };
        }
        case Dt:
          return {
            ...s,
            status: "error",
            error: n.data,
            input: void 0
          };
        case z:
          return K.get(i.self)?.abort(), {
            ...s,
            status: "stopped",
            input: void 0
          };
        default:
          return s;
      }
    },
    start: (s, {
      self: n,
      system: i,
      emit: r
    }) => {
      if (s.status !== "active")
        return;
      const o = new AbortController();
      K.set(n, o), Promise.resolve(t({
        input: s.input,
        system: i,
        self: n,
        signal: o.signal,
        emit: r
      })).then((c) => {
        n.getSnapshot().status === "active" && (K.delete(n), i._relay(n, n, {
          type: Ft,
          data: c
        }));
      }, (c) => {
        n.getSnapshot().status === "active" && (K.delete(n), i._relay(n, n, {
          type: Dt,
          data: c
        }));
      });
    },
    getInitialSnapshot: (s, n) => ({
      status: "active",
      output: void 0,
      error: void 0,
      input: n
    }),
    getPersistedSnapshot: (s) => s,
    restoreSnapshot: (s) => s
  };
}
function ys(t, {
  machine: e,
  context: s
}, n, i) {
  const r = (o, a) => {
    if (typeof o == "string") {
      const c = gt(e, o);
      if (!c)
        throw new Error(`Actor logic '${o}' not implemented in machine '${e.id}'`);
      const f = J(c, {
        id: a?.id,
        parent: t.self,
        syncSnapshot: a?.syncSnapshot,
        input: typeof a?.input == "function" ? a.input({
          context: s,
          event: n,
          self: t.self
        }) : a?.input,
        src: o,
        systemId: a?.systemId
      });
      return i[f.id] = f, f;
    } else
      return J(o, {
        id: a?.id,
        parent: t.self,
        syncSnapshot: a?.syncSnapshot,
        input: a?.input,
        src: o,
        systemId: a?.systemId
      });
  };
  return (o, a) => {
    const c = r(o, a);
    return i[c.id] = c, t.defer(() => {
      c._processingStatus !== S.Stopped && c.start();
    }), c;
  };
}
function gs(t, e, s, n, {
  assignment: i
}) {
  if (!e.context)
    throw new Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
  const r = {}, o = {
    context: e.context,
    event: s.event,
    spawn: ys(t, e, s.event, r),
    self: t.self,
    system: t.system
  };
  let a = {};
  if (typeof i == "function")
    a = i(o, n);
  else
    for (const f of Object.keys(i)) {
      const p = i[f];
      a[f] = typeof p == "function" ? p(o, n) : p;
    }
  const c = Object.assign({}, e.context, a);
  return [I(e, {
    context: c,
    children: Object.keys(r).length ? {
      ...e.children,
      ...r
    } : e.children
  }), void 0, void 0];
}
function ms(t) {
  function e(s, n) {
  }
  return e.type = "xstate.assign", e.assignment = t, e.resolve = gs, e;
}
const Rt = /* @__PURE__ */ new WeakMap();
function M(t, e, s) {
  let n = Rt.get(t);
  return n ? e in n || (n[e] = s()) : (n = {
    [e]: s()
  }, Rt.set(t, n)), n[e];
}
const vs = {}, $ = (t) => typeof t == "string" ? {
  type: t
} : typeof t == "function" ? "resolve" in t ? {
  type: t.type
} : {
  type: t.name
} : t;
class Y {
  constructor(e, s) {
    if (this.config = e, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = s._parent, this.key = s._key, this.machine = s._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join(Kt), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? At(this.config.states, (n, i) => new Y(n, {
      _parent: this,
      _key: i,
      _machine: this.machine
    })) : vs, this.type === "compound" && !this.config.initial)
      throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
    this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = E(this.config.entry).slice(), this.exit = E(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = E(e.tags).slice();
  }
  /** @internal */
  _initialize() {
    this.transitions = Ue(this), this.config.always && (this.always = C(this.config.always).map((e) => T(this, Ht, e))), Object.keys(this.states).forEach((e) => {
      this.states[e]._initialize();
    });
  }
  /** The well-structured state node definition. */
  get definition() {
    return {
      id: this.id,
      key: this.key,
      version: this.machine.version,
      type: this.type,
      initial: this.initial ? {
        target: this.initial.target,
        source: this,
        actions: this.initial.actions.map($),
        eventType: null,
        reenter: !1,
        toJSON: () => ({
          target: this.initial.target.map((e) => `#${e.id}`),
          source: `#${this.id}`,
          actions: this.initial.actions.map($),
          eventType: null
        })
      } : void 0,
      history: this.history,
      states: At(this.states, (e) => e.definition),
      on: this.on,
      transitions: [...this.transitions.values()].flat().map((e) => ({
        ...e,
        actions: e.actions.map($)
      })),
      entry: this.entry.map($),
      exit: this.exit.map($),
      meta: this.meta,
      order: this.order || -1,
      output: this.output,
      invoke: this.invoke,
      description: this.description,
      tags: this.tags
    };
  }
  /** @internal */
  toJSON() {
    return this.definition;
  }
  /** The logic invoked as actors by this state node. */
  get invoke() {
    return M(this, "invoke", () => E(this.config.invoke).map((e, s) => {
      const {
        src: n,
        systemId: i
      } = e, r = e.id ?? It(this.id, s), o = typeof n == "string" ? n : `xstate.invoke.${It(this.id, s)}`;
      return {
        ...e,
        src: o,
        id: r,
        systemId: i,
        toJSON() {
          const {
            onDone: a,
            onError: c,
            ...f
          } = e;
          return {
            ...f,
            type: "xstate.invoke",
            src: o,
            id: r
          };
        }
      };
    }));
  }
  /** The mapping of events to transitions. */
  get on() {
    return M(this, "on", () => [...this.transitions].flatMap(([s, n]) => n.map((i) => [s, i])).reduce((s, [n, i]) => (s[n] = s[n] || [], s[n].push(i), s), {}));
  }
  get after() {
    return M(this, "delayedTransitions", () => Le(this));
  }
  get initial() {
    return M(this, "initial", () => Ke(this, this.config.initial));
  }
  /** @internal */
  next(e, s) {
    const n = s.type, i = [];
    let r;
    const o = M(this, `candidates-${n}`, () => Qe(this, n));
    for (const a of o) {
      const {
        guard: c
      } = a, f = e.context;
      let p = !1;
      try {
        p = !c || N(c, f, s, e);
      } catch (u) {
        const h = typeof c == "string" ? c : typeof c == "object" ? c.type : void 0;
        throw new Error(`Unable to evaluate guard ${h ? `'${h}' ` : ""}in transition for event '${n}' in state node '${this.id}':
${u.message}`);
      }
      if (p) {
        i.push(...a.actions), r = a;
        break;
      }
    }
    return r ? [r] : void 0;
  }
  /** All the event types accepted by this state node and its descendants. */
  get events() {
    return M(this, "events", () => {
      const {
        states: e
      } = this, s = new Set(this.ownEvents);
      if (e)
        for (const n of Object.keys(e)) {
          const i = e[n];
          if (i.states)
            for (const r of i.events)
              s.add(`${r}`);
        }
      return Array.from(s);
    });
  }
  /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */
  get ownEvents() {
    const e = new Set([...this.transitions.keys()].filter((s) => this.transitions.get(s).some((n) => !(!n.target && !n.actions.length && !n.reenter))));
    return Array.from(e);
  }
}
const bs = "#";
class wt {
  constructor(e, s) {
    this.config = e, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = e.id || "(machine)", this.implementations = {
      actors: s?.actors ?? {},
      actions: s?.actions ?? {},
      delays: s?.delays ?? {},
      guards: s?.guards ?? {}
    }, this.version = this.config.version, this.schemas = this.config.schemas, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new Y(e, {
      _key: this.id,
      _machine: this
    }), this.root._initialize(), this.states = this.root.states, this.events = this.root.events;
  }
  /**
   * Clones this state machine with the provided implementations.
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`) to
   *   recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */
  provide(e) {
    const {
      actions: s,
      guards: n,
      actors: i,
      delays: r
    } = this.implementations;
    return new wt(this.config, {
      actions: {
        ...s,
        ...e.actions
      },
      guards: {
        ...n,
        ...e.guards
      },
      actors: {
        ...i,
        ...e.actors
      },
      delays: {
        ...r,
        ...e.delays
      }
    });
  }
  resolveState(e) {
    const s = ns(this.root, e.value), n = B(X(this.root, s));
    return G({
      _nodes: [...n],
      context: e.context || {},
      children: {},
      status: bt(n, this.root) ? "done" : e.status || "active",
      output: e.output,
      error: e.error,
      historyValue: e.historyValue
    }, this);
  }
  /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */
  transition(e, s, n) {
    return it(e, s, n, []).snapshot;
  }
  /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */
  microstep(e, s, n) {
    return it(e, s, n, []).microstates;
  }
  getTransitionData(e, s) {
    return St(this.root, e.value, e, s) || [];
  }
  /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */
  getPreInitialState(e, s, n) {
    const {
      context: i
    } = this.config, r = G({
      context: typeof i != "function" && i ? i : {},
      _nodes: [this.root],
      children: {},
      status: "active"
    }, this);
    return typeof i == "function" ? R(r, s, e, [ms(({
      spawn: a,
      event: c,
      self: f
    }) => i({
      spawn: a,
      input: c.input,
      self: f
    }))], n, void 0) : r;
  }
  /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */
  getInitialSnapshot(e, s) {
    const n = zt(s), i = [], r = this.getPreInitialState(e, n, i), o = ft([{
      target: [...ee(this.root)],
      source: this.root,
      reenter: !0,
      actions: [],
      eventType: null,
      toJSON: null
      // TODO: fix
    }], r, e, n, !0, i), {
      snapshot: a
    } = it(o, n, e, i);
    return a;
  }
  start(e) {
    Object.values(e.children).forEach((s) => {
      s.getSnapshot().status === "active" && s.start();
    });
  }
  getStateNodeById(e) {
    const s = yt(e), n = s.slice(1), i = tt(s[0]) ? s[0].slice(bs.length) : s[0], r = this.idMap.get(i);
    if (!r)
      throw new Error(`Child state node '#${i}' does not exist on machine '${this.id}'`);
    return W(r, n);
  }
  get definition() {
    return this.root.definition;
  }
  toJSON() {
    return this.definition;
  }
  getPersistedSnapshot(e, s) {
    return fs(e, s);
  }
  restoreSnapshot(e, s) {
    const n = {}, i = e.children;
    Object.keys(i).forEach((u) => {
      const h = i[u], d = h.snapshot, l = h.src, y = typeof l == "string" ? gt(this, l) : l;
      if (!y)
        return;
      const g = J(y, {
        id: u,
        parent: s.self,
        syncSnapshot: h.syncSnapshot,
        snapshot: d,
        src: l,
        systemId: h.systemId
      });
      n[u] = g;
    });
    function r(u, h) {
      if (h instanceof Y)
        return h;
      try {
        return u.machine.getStateNodeById(h.id);
      } catch {
      }
    }
    function o(u, h) {
      if (!h || typeof h != "object")
        return {};
      const d = {};
      for (const l in h) {
        const y = h[l];
        for (const g of y) {
          const m = r(u, g);
          m && (d[l] ??= [], d[l].push(m));
        }
      }
      return d;
    }
    const a = o(this.root, e.historyValue), c = G({
      ...e,
      children: n,
      _nodes: Array.from(B(X(this.root, e.value))),
      historyValue: a
    }, this), f = /* @__PURE__ */ new Set();
    function p(u, h) {
      if (!f.has(u)) {
        f.add(u);
        for (const d in u) {
          const l = u[d];
          if (l && typeof l == "object") {
            if ("xstate$$type" in l && l.xstate$$type === mt) {
              u[d] = h[l.id];
              continue;
            }
            p(l, h);
          }
        }
      }
    }
    return p(c.context, n), c;
  }
}
function Ss(t, e, s, n, {
  event: i
}) {
  const r = typeof i == "function" ? i(s, n) : i;
  return [e, {
    event: r
  }, void 0];
}
function _s(t, {
  event: e
}) {
  t.defer(() => t.emit(e));
}
function Xs(t) {
  function e(s, n) {
  }
  return e.type = "xstate.emit", e.event = t, e.resolve = Ss, e.execute = _s, e;
}
function ws(t, e) {
  return new wt(t, e);
}
function Ys({
  schemas: t,
  actors: e,
  actions: s,
  guards: n,
  delays: i
}) {
  return {
    createMachine: (r) => ws({
      ...r,
      schemas: t
    }, {
      actors: e,
      actions: s,
      guards: n,
      delays: i
    })
  };
}
var Q = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, et = typeof window > "u" || "Deno" in globalThis;
function _() {
}
function Es(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function xs(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function Os(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function lt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Ts(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function $t(t, e) {
  const {
    type: s = "all",
    exact: n,
    fetchStatus: i,
    predicate: r,
    queryKey: o,
    stale: a
  } = t;
  if (o) {
    if (n) {
      if (e.queryHash !== Et(o, e.options))
        return !1;
    } else if (!j(e.queryKey, o))
      return !1;
  }
  if (s !== "all") {
    const c = e.isActive();
    if (s === "active" && !c || s === "inactive" && c)
      return !1;
  }
  return !(typeof a == "boolean" && e.isStale() !== a || i && i !== e.state.fetchStatus || r && !r(e));
}
function jt(t, e) {
  const { exact: s, status: n, predicate: i, mutationKey: r } = t;
  if (r) {
    if (!e.options.mutationKey)
      return !1;
    if (s) {
      if (k(e.options.mutationKey) !== k(r))
        return !1;
    } else if (!j(e.options.mutationKey, r))
      return !1;
  }
  return !(n && e.state.status !== n || i && !i(e));
}
function Et(t, e) {
  return (e?.queryKeyHashFn || k)(t);
}
function k(t) {
  return JSON.stringify(
    t,
    (e, s) => pt(s) ? Object.keys(s).sort().reduce((n, i) => (n[i] = s[i], n), {}) : s
  );
}
function j(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? Object.keys(e).every((s) => j(t[s], e[s])) : !1;
}
function dt(t, e) {
  if (t === e)
    return t;
  const s = qt(t) && qt(e);
  if (s || pt(t) && pt(e)) {
    const n = s ? t : Object.keys(t), i = n.length, r = s ? e : Object.keys(e), o = r.length, a = s ? [] : {}, c = new Set(n);
    let f = 0;
    for (let p = 0; p < o; p++) {
      const u = s ? p : r[p];
      (!s && c.has(u) || s) && t[u] === void 0 && e[u] === void 0 ? (a[u] = void 0, f++) : (a[u] = dt(t[u], e[u]), a[u] === t[u] && t[u] !== void 0 && f++);
    }
    return i === o && f === i ? t : a;
  }
  return e;
}
function As(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const s in t)
    if (t[s] !== e[s])
      return !1;
  return !0;
}
function qt(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function pt(t) {
  if (!Qt(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const s = e.prototype;
  return !(!Qt(s) || !s.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function Qt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Is(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function ks(t, e, s) {
  if (typeof s.structuralSharing == "function")
    return s.structuralSharing(t, e);
  if (s.structuralSharing !== !1) {
    try {
      return dt(t, e);
    } catch (n) {
      throw console.error(
        `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${s.queryHash}]: ${n}`
      ), n;
    }
    return dt(t, e);
  }
  return e;
}
function Ms(t, e, s = 0) {
  const n = [...t, e];
  return s && n.length > s ? n.slice(1) : n;
}
function Cs(t, e, s = 0) {
  const n = [e, ...t];
  return s && n.length > s ? n.slice(0, -1) : n;
}
var V = Symbol();
function ae(t, e) {
  return t.queryFn === V && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && e?.initialPromise ? () => e.initialPromise : !t.queryFn || t.queryFn === V ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
var Ps = class extends Q {
  #t;
  #e;
  #s;
  constructor() {
    super(), this.#s = (t) => {
      if (!et && window.addEventListener) {
        const e = () => t();
        return window.addEventListener("visibilitychange", e, !1), () => {
          window.removeEventListener("visibilitychange", e);
        };
      }
    };
  }
  onSubscribe() {
    this.#e || this.setEventListener(this.#s);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#e?.(), this.#e = void 0);
  }
  setEventListener(t) {
    this.#s = t, this.#e?.(), this.#e = t((e) => {
      typeof e == "boolean" ? this.setFocused(e) : this.onFocus();
    });
  }
  setFocused(t) {
    this.#t !== t && (this.#t = t, this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((e) => {
      e(t);
    });
  }
  isFocused() {
    return typeof this.#t == "boolean" ? this.#t : globalThis.document?.visibilityState !== "hidden";
  }
}, ce = new Ps(), Fs = class extends Q {
  #t = !0;
  #e;
  #s;
  constructor() {
    super(), this.#s = (t) => {
      if (!et && window.addEventListener) {
        const e = () => t(!0), s = () => t(!1);
        return window.addEventListener("online", e, !1), window.addEventListener("offline", s, !1), () => {
          window.removeEventListener("online", e), window.removeEventListener("offline", s);
        };
      }
    };
  }
  onSubscribe() {
    this.#e || this.setEventListener(this.#s);
  }
  onUnsubscribe() {
    this.hasListeners() || (this.#e?.(), this.#e = void 0);
  }
  setEventListener(t) {
    this.#s = t, this.#e?.(), this.#e = t(this.setOnline.bind(this));
  }
  setOnline(t) {
    this.#t !== t && (this.#t = t, this.listeners.forEach((s) => {
      s(t);
    }));
  }
  isOnline() {
    return this.#t;
  }
}, Z = new Fs();
function Ds() {
  let t, e;
  const s = new Promise((i, r) => {
    t = i, e = r;
  });
  s.status = "pending", s.catch(() => {
  });
  function n(i) {
    Object.assign(s, i), delete s.resolve, delete s.reject;
  }
  return s.resolve = (i) => {
    n({
      status: "fulfilled",
      value: i
    }), t(i);
  }, s.reject = (i) => {
    n({
      status: "rejected",
      reason: i
    }), e(i);
  }, s;
}
function Rs(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function ue(t) {
  return (t ?? "online") === "online" ? Z.isOnline() : !0;
}
var he = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t?.revert, this.silent = t?.silent;
  }
};
function rt(t) {
  return t instanceof he;
}
function fe(t) {
  let e = !1, s = 0, n = !1, i;
  const r = Ds(), o = (y) => {
    n || (h(new he(y)), t.abort?.());
  }, a = () => {
    e = !0;
  }, c = () => {
    e = !1;
  }, f = () => ce.isFocused() && (t.networkMode === "always" || Z.isOnline()) && t.canRun(), p = () => ue(t.networkMode) && t.canRun(), u = (y) => {
    n || (n = !0, t.onSuccess?.(y), i?.(), r.resolve(y));
  }, h = (y) => {
    n || (n = !0, t.onError?.(y), i?.(), r.reject(y));
  }, d = () => new Promise((y) => {
    i = (g) => {
      (n || f()) && y(g);
    }, t.onPause?.();
  }).then(() => {
    i = void 0, n || t.onContinue?.();
  }), l = () => {
    if (n)
      return;
    let y;
    const g = s === 0 ? t.initialPromise : void 0;
    try {
      y = g ?? t.fn();
    } catch (m) {
      y = Promise.reject(m);
    }
    Promise.resolve(y).then(u).catch((m) => {
      if (n)
        return;
      const b = t.retry ?? (et ? 0 : 3), O = t.retryDelay ?? Rs, L = typeof O == "function" ? O(s, m) : O, U = b === !0 || typeof b == "number" && s < b || typeof b == "function" && b(s, m);
      if (e || !U) {
        h(m);
        return;
      }
      s++, t.onFail?.(s, m), Is(L).then(() => f() ? void 0 : d()).then(() => {
        e ? h(m) : l();
      });
    });
  };
  return {
    promise: r,
    cancel: o,
    continue: () => (i?.(), r),
    cancelRetry: a,
    continueRetry: c,
    canStart: p,
    start: () => (p() ? l() : d().then(l), r)
  };
}
var $s = (t) => setTimeout(t, 0);
function js() {
  let t = [], e = 0, s = (a) => {
    a();
  }, n = (a) => {
    a();
  }, i = $s;
  const r = (a) => {
    e ? t.push(a) : i(() => {
      s(a);
    });
  }, o = () => {
    const a = t;
    t = [], a.length && i(() => {
      n(() => {
        a.forEach((c) => {
          s(c);
        });
      });
    });
  };
  return {
    batch: (a) => {
      let c;
      e++;
      try {
        c = a();
      } finally {
        e--, e || o();
      }
      return c;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (a) => (...c) => {
      r(() => {
        a(...c);
      });
    },
    schedule: r,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (a) => {
      s = a;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (a) => {
      n = a;
    },
    setScheduler: (a) => {
      i = a;
    }
  };
}
var v = js(), le = class {
  #t;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), xs(this.gcTime) && (this.#t = setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? (et ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    this.#t && (clearTimeout(this.#t), this.#t = void 0);
  }
}, qs = class extends le {
  #t;
  #e;
  #s;
  #n;
  #i;
  #o;
  #a;
  constructor(t) {
    super(), this.#a = !1, this.#o = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.#n = t.client, this.#s = this.#n.getQueryCache(), this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.#t = Ls(this.options), this.state = t.state ?? this.#t, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    return this.#i?.promise;
  }
  setOptions(t) {
    this.options = { ...this.#o, ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.#s.remove(this);
  }
  setData(t, e) {
    const s = ks(this.state.data, t, this.options);
    return this.#r({
      data: s,
      type: "success",
      dataUpdatedAt: e?.updatedAt,
      manual: e?.manual
    }), s;
  }
  setState(t, e) {
    this.#r({ type: "setState", state: t, setStateOptions: e });
  }
  cancel(t) {
    const e = this.#i?.promise;
    return this.#i?.cancel(t), e ? e.then(_).catch(_) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(this.#t);
  }
  isActive() {
    return this.observers.some(
      (t) => Ts(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === V || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => lt(t.options.staleTime, this) === "static"
    ) : !1;
  }
  isStale() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(t = 0) {
    return this.state.data === void 0 ? !0 : t === "static" ? !1 : this.state.isInvalidated ? !0 : !Os(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    this.observers.find((e) => e.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#i?.continue();
  }
  onOnline() {
    this.observers.find((e) => e.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#i?.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.#s.notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((e) => e !== t), this.observers.length || (this.#i && (this.#a ? this.#i.cancel({ revert: !0 }) : this.#i.cancelRetry()), this.scheduleGc()), this.#s.notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.#r({ type: "invalidate" });
  }
  fetch(t, e) {
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && e?.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (this.#i)
        return this.#i.continueRetry(), this.#i.promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const c = this.observers.find((f) => f.options.queryFn);
      c && this.setOptions(c.options);
    }
    Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    );
    const s = new AbortController(), n = (c) => {
      Object.defineProperty(c, "signal", {
        enumerable: !0,
        get: () => (this.#a = !0, s.signal)
      });
    }, i = () => {
      const c = ae(this.options, e), p = (() => {
        const u = {
          client: this.#n,
          queryKey: this.queryKey,
          meta: this.meta
        };
        return n(u), u;
      })();
      return this.#a = !1, this.options.persister ? this.options.persister(
        c,
        p,
        this
      ) : c(p);
    }, o = (() => {
      const c = {
        fetchOptions: e,
        options: this.options,
        queryKey: this.queryKey,
        client: this.#n,
        state: this.state,
        fetchFn: i
      };
      return n(c), c;
    })();
    this.options.behavior?.onFetch(o, this), this.#e = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== o.fetchOptions?.meta) && this.#r({ type: "fetch", meta: o.fetchOptions?.meta });
    const a = (c) => {
      rt(c) && c.silent || this.#r({
        type: "error",
        error: c
      }), rt(c) || (this.#s.config.onError?.(
        c,
        this
      ), this.#s.config.onSettled?.(
        this.state.data,
        c,
        this
      )), this.scheduleGc();
    };
    return this.#i = fe({
      initialPromise: e?.initialPromise,
      fn: o.fetchFn,
      abort: s.abort.bind(s),
      onSuccess: (c) => {
        if (c === void 0) {
          console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), a(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(c);
        } catch (f) {
          a(f);
          return;
        }
        this.#s.config.onSuccess?.(c, this), this.#s.config.onSettled?.(
          c,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: a,
      onFail: (c, f) => {
        this.#r({ type: "failed", failureCount: c, error: f });
      },
      onPause: () => {
        this.#r({ type: "pause" });
      },
      onContinue: () => {
        this.#r({ type: "continue" });
      },
      retry: o.options.retry,
      retryDelay: o.options.retryDelay,
      networkMode: o.options.networkMode,
      canRun: () => !0
    }), this.#i.start();
  }
  #r(t) {
    const e = (s) => {
      switch (t.type) {
        case "failed":
          return {
            ...s,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...s,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...s,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...s,
            ...Qs(s.data, this.options),
            fetchMeta: t.meta ?? null
          };
        case "success":
          return this.#e = void 0, {
            ...s,
            data: t.data,
            dataUpdateCount: s.dataUpdateCount + 1,
            dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const n = t.error;
          return rt(n) && n.revert && this.#e ? { ...this.#e, fetchStatus: "idle" } : {
            ...s,
            error: n,
            errorUpdateCount: s.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: s.fetchFailureCount + 1,
            fetchFailureReason: n,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...s,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...s,
            ...t.state
          };
      }
    };
    this.state = e(this.state), v.batch(() => {
      this.observers.forEach((s) => {
        s.onQueryUpdate();
      }), this.#s.notify({ query: this, type: "updated", action: t });
    });
  }
};
function Qs(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: ue(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Ls(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, s = e !== void 0, n = s ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: s ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: s ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Us = class extends Q {
  constructor(t = {}) {
    super(), this.config = t, this.#t = /* @__PURE__ */ new Map();
  }
  #t;
  build(t, e, s) {
    const n = e.queryKey, i = e.queryHash ?? Et(n, e);
    let r = this.get(i);
    return r || (r = new qs({
      client: t,
      queryKey: n,
      queryHash: i,
      options: t.defaultQueryOptions(e),
      state: s,
      defaultOptions: t.getQueryDefaults(n)
    }), this.add(r)), r;
  }
  add(t) {
    this.#t.has(t.queryHash) || (this.#t.set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const e = this.#t.get(t.queryHash);
    e && (t.destroy(), e === t && this.#t.delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    v.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.#t.get(t);
  }
  getAll() {
    return [...this.#t.values()];
  }
  find(t) {
    const e = { exact: !0, ...t };
    return this.getAll().find(
      (s) => $t(e, s)
    );
  }
  findAll(t = {}) {
    const e = this.getAll();
    return Object.keys(t).length > 0 ? e.filter((s) => $t(t, s)) : e;
  }
  notify(t) {
    v.batch(() => {
      this.listeners.forEach((e) => {
        e(t);
      });
    });
  }
  onFocus() {
    v.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    v.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, Ks = class extends le {
  #t;
  #e;
  #s;
  constructor(t) {
    super(), this.mutationId = t.mutationId, this.#e = t.mutationCache, this.#t = [], this.state = t.state || de(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    this.#t.includes(t) || (this.#t.push(t), this.clearGcTimeout(), this.#e.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.#t = this.#t.filter((e) => e !== t), this.scheduleGc(), this.#e.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.#t.length || (this.state.status === "pending" ? this.scheduleGc() : this.#e.remove(this));
  }
  continue() {
    return this.#s?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    const e = () => {
      this.#n({ type: "continue" });
    };
    this.#s = fe({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (i, r) => {
        this.#n({ type: "failed", failureCount: i, error: r });
      },
      onPause: () => {
        this.#n({ type: "pause" });
      },
      onContinue: e,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => this.#e.canRun(this)
    });
    const s = this.state.status === "pending", n = !this.#s.canStart();
    try {
      if (s)
        e();
      else {
        this.#n({ type: "pending", variables: t, isPaused: n }), await this.#e.config.onMutate?.(
          t,
          this
        );
        const r = await this.options.onMutate?.(t);
        r !== this.state.context && this.#n({
          type: "pending",
          context: r,
          variables: t,
          isPaused: n
        });
      }
      const i = await this.#s.start();
      return await this.#e.config.onSuccess?.(
        i,
        t,
        this.state.context,
        this
      ), await this.options.onSuccess?.(i, t, this.state.context), await this.#e.config.onSettled?.(
        i,
        null,
        this.state.variables,
        this.state.context,
        this
      ), await this.options.onSettled?.(i, null, t, this.state.context), this.#n({ type: "success", data: i }), i;
    } catch (i) {
      try {
        throw await this.#e.config.onError?.(
          i,
          t,
          this.state.context,
          this
        ), await this.options.onError?.(
          i,
          t,
          this.state.context
        ), await this.#e.config.onSettled?.(
          void 0,
          i,
          this.state.variables,
          this.state.context,
          this
        ), await this.options.onSettled?.(
          void 0,
          i,
          t,
          this.state.context
        ), i;
      } finally {
        this.#n({ type: "error", error: i });
      }
    } finally {
      this.#e.runNext(this);
    }
  }
  #n(t) {
    const e = (s) => {
      switch (t.type) {
        case "failed":
          return {
            ...s,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...s,
            isPaused: !0
          };
        case "continue":
          return {
            ...s,
            isPaused: !1
          };
        case "pending":
          return {
            ...s,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: t.isPaused,
            status: "pending",
            variables: t.variables,
            submittedAt: Date.now()
          };
        case "success":
          return {
            ...s,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...s,
            data: void 0,
            error: t.error,
            failureCount: s.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
      }
    };
    this.state = e(this.state), v.batch(() => {
      this.#t.forEach((s) => {
        s.onMutationUpdate(t);
      }), this.#e.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
};
function de() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Hs = class extends Q {
  constructor(t = {}) {
    super(), this.config = t, this.#t = /* @__PURE__ */ new Set(), this.#e = /* @__PURE__ */ new Map(), this.#s = 0;
  }
  #t;
  #e;
  #s;
  build(t, e, s) {
    const n = new Ks({
      mutationCache: this,
      mutationId: ++this.#s,
      options: t.defaultMutationOptions(e),
      state: s
    });
    return this.add(n), n;
  }
  add(t) {
    this.#t.add(t);
    const e = H(t);
    if (typeof e == "string") {
      const s = this.#e.get(e);
      s ? s.push(t) : this.#e.set(e, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (this.#t.delete(t)) {
      const e = H(t);
      if (typeof e == "string") {
        const s = this.#e.get(e);
        if (s)
          if (s.length > 1) {
            const n = s.indexOf(t);
            n !== -1 && s.splice(n, 1);
          } else s[0] === t && this.#e.delete(e);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const e = H(t);
    if (typeof e == "string") {
      const n = this.#e.get(e)?.find(
        (i) => i.state.status === "pending"
      );
      return !n || n === t;
    } else
      return !0;
  }
  runNext(t) {
    const e = H(t);
    return typeof e == "string" ? this.#e.get(e)?.find((n) => n !== t && n.state.isPaused)?.continue() ?? Promise.resolve() : Promise.resolve();
  }
  clear() {
    v.batch(() => {
      this.#t.forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), this.#t.clear(), this.#e.clear();
    });
  }
  getAll() {
    return Array.from(this.#t);
  }
  find(t) {
    const e = { exact: !0, ...t };
    return this.getAll().find(
      (s) => jt(e, s)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((e) => jt(t, e));
  }
  notify(t) {
    v.batch(() => {
      this.listeners.forEach((e) => {
        e(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((e) => e.state.isPaused);
    return v.batch(
      () => Promise.all(
        t.map((e) => e.continue().catch(_))
      )
    );
  }
};
function H(t) {
  return t.options.scope?.id;
}
function Lt(t) {
  return {
    onFetch: (e, s) => {
      const n = e.options, i = e.fetchOptions?.meta?.fetchMore?.direction, r = e.state.data?.pages || [], o = e.state.data?.pageParams || [];
      let a = { pages: [], pageParams: [] }, c = 0;
      const f = async () => {
        let p = !1;
        const u = (l) => {
          Object.defineProperty(l, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? p = !0 : e.signal.addEventListener("abort", () => {
              p = !0;
            }), e.signal)
          });
        }, h = ae(e.options, e.fetchOptions), d = async (l, y, g) => {
          if (p)
            return Promise.reject();
          if (y == null && l.pages.length)
            return Promise.resolve(l);
          const b = (() => {
            const xt = {
              client: e.client,
              queryKey: e.queryKey,
              pageParam: y,
              direction: g ? "backward" : "forward",
              meta: e.options.meta
            };
            return u(xt), xt;
          })(), O = await h(b), { maxPages: L } = e.options, U = g ? Cs : Ms;
          return {
            pages: U(l.pages, O, L),
            pageParams: U(l.pageParams, y, L)
          };
        };
        if (i && r.length) {
          const l = i === "backward", y = l ? Gs : Ut, g = {
            pages: r,
            pageParams: o
          }, m = y(n, g);
          a = await d(g, m, l);
        } else {
          const l = t ?? r.length;
          do {
            const y = c === 0 ? o[0] ?? n.initialPageParam : Ut(n, a);
            if (c > 0 && y == null)
              break;
            a = await d(a, y), c++;
          } while (c < l);
        }
        return a;
      };
      e.options.persister ? e.fetchFn = () => e.options.persister?.(
        f,
        {
          client: e.client,
          queryKey: e.queryKey,
          meta: e.options.meta,
          signal: e.signal
        },
        s
      ) : e.fetchFn = f;
    }
  };
}
function Ut(t, { pages: e, pageParams: s }) {
  const n = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[n],
    e,
    s[n],
    s
  ) : void 0;
}
function Gs(t, { pages: e, pageParams: s }) {
  return e.length > 0 ? t.getPreviousPageParam?.(e[0], e, s[0], s) : void 0;
}
var Vs = class {
  #t;
  #e;
  #s;
  #n;
  #i;
  #o;
  #a;
  #r;
  constructor(t = {}) {
    this.#t = t.queryCache || new Us(), this.#e = t.mutationCache || new Hs(), this.#s = t.defaultOptions || {}, this.#n = /* @__PURE__ */ new Map(), this.#i = /* @__PURE__ */ new Map(), this.#o = 0;
  }
  mount() {
    this.#o++, this.#o === 1 && (this.#a = ce.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), this.#t.onFocus());
    }), this.#r = Z.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), this.#t.onOnline());
    }));
  }
  unmount() {
    this.#o--, this.#o === 0 && (this.#a?.(), this.#a = void 0, this.#r?.(), this.#r = void 0);
  }
  isFetching(t) {
    return this.#t.findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return this.#e.findAll({ ...t, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(t) {
    const e = this.defaultQueryOptions({ queryKey: t });
    return this.#t.get(e.queryHash)?.state.data;
  }
  ensureQueryData(t) {
    const e = this.defaultQueryOptions(t), s = this.#t.build(this, e), n = s.state.data;
    return n === void 0 ? this.fetchQuery(t) : (t.revalidateIfStale && s.isStaleByTime(lt(e.staleTime, s)) && this.prefetchQuery(e), Promise.resolve(n));
  }
  getQueriesData(t) {
    return this.#t.findAll(t).map(({ queryKey: e, state: s }) => {
      const n = s.data;
      return [e, n];
    });
  }
  setQueryData(t, e, s) {
    const n = this.defaultQueryOptions({ queryKey: t }), r = this.#t.get(
      n.queryHash
    )?.state.data, o = Es(e, r);
    if (o !== void 0)
      return this.#t.build(this, n).setData(o, { ...s, manual: !0 });
  }
  setQueriesData(t, e, s) {
    return v.batch(
      () => this.#t.findAll(t).map(({ queryKey: n }) => [
        n,
        this.setQueryData(n, e, s)
      ])
    );
  }
  getQueryState(t) {
    const e = this.defaultQueryOptions({ queryKey: t });
    return this.#t.get(
      e.queryHash
    )?.state;
  }
  removeQueries(t) {
    const e = this.#t;
    v.batch(() => {
      e.findAll(t).forEach((s) => {
        e.remove(s);
      });
    });
  }
  resetQueries(t, e) {
    const s = this.#t;
    return v.batch(() => (s.findAll(t).forEach((n) => {
      n.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...t
      },
      e
    )));
  }
  cancelQueries(t, e = {}) {
    const s = { revert: !0, ...e }, n = v.batch(
      () => this.#t.findAll(t).map((i) => i.cancel(s))
    );
    return Promise.all(n).then(_).catch(_);
  }
  invalidateQueries(t, e = {}) {
    return v.batch(() => (this.#t.findAll(t).forEach((s) => {
      s.invalidate();
    }), t?.refetchType === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...t,
        type: t?.refetchType ?? t?.type ?? "active"
      },
      e
    )));
  }
  refetchQueries(t, e = {}) {
    const s = {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }, n = v.batch(
      () => this.#t.findAll(t).filter((i) => !i.isDisabled() && !i.isStatic()).map((i) => {
        let r = i.fetch(void 0, s);
        return s.throwOnError || (r = r.catch(_)), i.state.fetchStatus === "paused" ? Promise.resolve() : r;
      })
    );
    return Promise.all(n).then(_);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const s = this.#t.build(this, e);
    return s.isStaleByTime(
      lt(e.staleTime, s)
    ) ? s.fetch(e) : Promise.resolve(s.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(_).catch(_);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = Lt(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(_).catch(_);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = Lt(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Z.isOnline() ? this.#e.resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return this.#t;
  }
  getMutationCache() {
    return this.#e;
  }
  getDefaultOptions() {
    return this.#s;
  }
  setDefaultOptions(t) {
    this.#s = t;
  }
  setQueryDefaults(t, e) {
    this.#n.set(k(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...this.#n.values()], s = {};
    return e.forEach((n) => {
      j(t, n.queryKey) && Object.assign(s, n.defaultOptions);
    }), s;
  }
  setMutationDefaults(t, e) {
    this.#i.set(k(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...this.#i.values()], s = {};
    return e.forEach((n) => {
      j(t, n.mutationKey) && Object.assign(s, n.defaultOptions);
    }), s;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...this.#s.queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = Et(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.queryFn === V && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t?._defaulted ? t : {
      ...this.#s.mutations,
      ...t?.mutationKey && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.#t.clear(), this.#e.clear();
  }
}, Zs = class extends Q {
  #t;
  #e = void 0;
  #s;
  #n;
  constructor(t, e) {
    super(), this.#t = t, this.setOptions(e), this.bindMethods(), this.#i();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    const e = this.options;
    this.options = this.#t.defaultMutationOptions(t), As(this.options, e) || this.#t.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.#s,
      observer: this
    }), e?.mutationKey && this.options.mutationKey && k(e.mutationKey) !== k(this.options.mutationKey) ? this.reset() : this.#s?.state.status === "pending" && this.#s.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#s?.removeObserver(this);
  }
  onMutationUpdate(t) {
    this.#i(), this.#o(t);
  }
  getCurrentResult() {
    return this.#e;
  }
  reset() {
    this.#s?.removeObserver(this), this.#s = void 0, this.#i(), this.#o();
  }
  mutate(t, e) {
    return this.#n = e, this.#s?.removeObserver(this), this.#s = this.#t.getMutationCache().build(this.#t, this.options), this.#s.addObserver(this), this.#s.execute(t);
  }
  #i() {
    const t = this.#s?.state ?? de();
    this.#e = {
      ...t,
      isPending: t.status === "pending",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #o(t) {
    v.batch(() => {
      if (this.#n && this.hasListeners()) {
        const e = this.#e.variables, s = this.#e.context;
        t?.type === "success" ? (this.#n.onSuccess?.(t.data, e, s), this.#n.onSettled?.(t.data, null, e, s)) : t?.type === "error" && (this.#n.onError?.(t.error, e, s), this.#n.onSettled?.(
          void 0,
          t.error,
          e,
          s
        ));
      }
      this.listeners.forEach((e) => {
        e(this.#e);
      });
    });
  }
}, ot;
// @__NO_SIDE_EFFECTS__
function zs(t) {
  return {
    lang: t?.lang ?? ot?.lang,
    message: t?.message,
    abortEarly: t?.abortEarly ?? ot?.abortEarly,
    abortPipeEarly: t?.abortPipeEarly ?? ot?.abortPipeEarly
  };
}
var Js = class extends Error {
  /**
   * Creates a Valibot error with useful information.
   *
   * @param issues The error issues.
   */
  constructor(t) {
    super(t[0].message), this.name = "ValiError", this.issues = t;
  }
};
function Ns(t, e, s) {
  const n = t["~run"]({ value: e }, /* @__PURE__ */ zs(s));
  if (n.issues)
    throw new Js(n.issues);
  return n.value;
}
export {
  Zs as M,
  Vs as Q,
  ms as a,
  Bs as b,
  J as c,
  Xs as e,
  Ws as f,
  Ns as p,
  Ys as s
};
//# sourceMappingURL=vendor-DxSylgwR.js.map
